"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentModerationRequestToJSON = exports.ContentModerationRequestFromJSONTyped = exports.ContentModerationRequestFromJSON = exports.instanceOfContentModerationRequest = void 0;
/**
 * Check if a given object implements the ContentModerationRequest interface.
 */
function instanceOfContentModerationRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "script" in value;
    return isInstance;
}
exports.instanceOfContentModerationRequest = instanceOfContentModerationRequest;
function ContentModerationRequestFromJSON(json) {
    return ContentModerationRequestFromJSONTyped(json, false);
}
exports.ContentModerationRequestFromJSON = ContentModerationRequestFromJSON;
function ContentModerationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'script': json['script'],
    };
}
exports.ContentModerationRequestFromJSONTyped = ContentModerationRequestFromJSONTyped;
function ContentModerationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'script': value.script,
    };
}
exports.ContentModerationRequestToJSON = ContentModerationRequestToJSON;
